export function ecdf(data) {
    const n = data.length, sorted = data.slice().sort(((a, b) => a - b));
    function evaluateSingle(x) {
        if (0 === n) return 0;
        let lo = 0, hi = n;
        for (;lo < hi; ) {
            const mid = lo + hi >>> 1;
            sorted[mid] <= x ? lo = mid + 1 : hi = mid;
        }
        return lo / n;
    }
    return {
        evaluate: function(x) {
            if (Array.isArray(x)) {
                const out = [];
                for (let i = 0; i < x.length; i++) out.push(evaluateSingle(x[i]));
                return out;
            }
            return evaluateSingle(x);
        },
        evaluateGrid: function(N) {
            const out = [];
            if (N <= 0) return out;
            if (0 === n) return out;
            const min = sorted[0], max = sorted[n - 1];
            if (min === max) {
                for (let i = 0; i < N; i++) out.push({
                    x: min,
                    y: 1
                });
                return out;
            }
            const step = (max - min) / (N - 1);
            for (let i = 0; i < N; i++) {
                const x = i === N - 1 ? max : min + step * i;
                out.push({
                    x: x,
                    y: evaluateSingle(x)
                });
            }
            return out;
        },
        n: n
    };
}

export default ecdf;
//# sourceMappingURL=ecdf.js.map